export default "__VITE_ASSET__CxxGUrnt__"